import { Controller } from "@hotwired/stimulus"
import { localStore, storeKeys } from "../lib/local_storage"
import { put } from "@rails/request.js"

// Connects to data-controller="theme-toggler"
export default class extends Controller {
  static values = {
    url: String
  }

  static targets = [ "input" ]

  async submit(event) {
    const previousTheme = document.documentElement.dataset.theme
    const requestedTheme = event.currentTarget.checked ? "dark" : "light"

    this.inputTarget.disabled = true
    this.applyTheme(requestedTheme)

    try {
      const response = await put(this.urlValue)
      if (!response.ok) throw new Error("Theme could not be persisted")

      const { theme } = await response.json
      this.inputTarget.checked = theme === "dark"
      this.applyTheme(theme)
    } catch {
      this.inputTarget.checked = previousTheme === "dark"
      this.applyTheme(previousTheme)
    } finally {
      this.inputTarget.disabled = false
    }
  }

  applyTheme(theme) {
    document.documentElement.dataset.theme = theme
    window.dispatchEvent(new CustomEvent("theme:change", { detail: { theme } }))
    localStore.set(storeKeys.theme, theme)
  }
}
